import axios from 'axios';
import { toLocalizedRiotUrl } from './../utils/language';

export const openAddPhoto = draftId => {
    const url = toLocalizedRiotUrl(`/selling/api/native-apps/add-photo`);
    return axios.post(url, {
        draftId
    });
};
